import React from "react"
import { Route, Redirect, withRouter } from "react-router-dom"
import { getCurRouter } from '../../util/utils'
import { routList } from '../../router/index'
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import './layout.less'

import TabBar from "./tabBar/tabBar";
import MBG from '../../assets/mBg.png';

let oldLocation = null;

const Layout = ({ location, history }) => {
  let { pathname } = location, _curRoute = getCurRouter(pathname, routList), { component, meta, isChild } = _curRoute||{}, { title, isTab, hideBg } = meta||{};
  document.title = title || '电摩资产认购平台';

  let _token = window.localStorage.getItem('token');
  if (pathname=='/login' || pathname=='/404') return <Route path={pathname} exact component={component} />;
  if (!_curRoute) return <Redirect to="/404" />
  if (!_token) return <Redirect to="/login" />

  //子菜单才设置转场动画
  let classNames = '';
  if (isChild){
    if(history.action === 'PUSH') classNames = 'slide-in';
    if(history.action === 'POP' && oldLocation) classNames = 'slide-out';
    oldLocation = location;   // 更新旧location
  }

  return (
    <div className={`layout-wrap ${hideBg ? '' : 'combg'}`}>
      {!hideBg && <img className="cbgimg" src={MBG} alt="" /> }
      <TransitionGroup className='main' childFactory={child => React.cloneElement(child, {classNames})}>
        <CSSTransition timeout={500} key={location.pathname}>
          <Route path={pathname} exact component={component} />
        </CSSTransition>
      </TransitionGroup>
      {isTab ? <TabBar /> : ''} 
    </div>
  )
}

export default withRouter(Layout);